import { ReactNode } from 'react';
import { ListItem } from '../common/Listitem';

import './FooterShareLink.scss';

export interface FooterShareLinkProps {
    badge: ReactNode;
    href: string;
    openInNewWindow?: boolean;
    title: string;
}

export const FooterShareLink = ({
    badge,
    href,
    openInNewWindow,
    title,
}: FooterShareLinkProps) => (
    <ListItem>
        <a
            className="footer__share-link"
            href={href}
            rel={openInNewWindow ? 'noreferrer' : undefined}
            target={openInNewWindow ? '_blank' : undefined}
            title={title}
        >
            {badge}
        </a>
    </ListItem>
);

export interface FooterShareLinksProps {
    children: ReactNode;
}

export const FooterShareLinks = ({ children }: FooterShareLinksProps) => (
    <div className="footer__share-links">{children}</div>
);
